import { GetReduceOptionsForDistribution } from "./index246.js";
const ReduceBasedOnDistribution = ({ count, distribution }) => {
	const i = GetReduceOptionsForDistribution({
		count,
		distribution
	})[0];
	count = count.slice();
	count[i]--;
	return count;
};
export { ReduceBasedOnDistribution };

//# sourceMappingURL=index247.js.map